/**
 * Rótulos em pt-BR para valores de enum que o backend devolve em inglês.
 * Use `labelPt(MAPA, valor)`: valor sem tradução cai no próprio valor,
 * então um enum novo nunca quebra a tela, só aparece sem tradução.
 */

export const ROLE_PT = {
  owner: "Proprietário", manager: "Gerente", staff: "Colaborador",
  accountant: "Contador", financial: "Financeiro", cashier: "Caixa",
  waiter: "Garçom", kitchen: "Cozinha",
};

export const GOAL_PERIOD_PT = { daily: "Diária", weekly: "Semanal", monthly: "Mensal" };
export const GOAL_TYPE_PT = { revenue: "Faturamento", profit: "Lucro", tickets: "Vendas", customers: "Clientes" };

export const RECURRENCE_PT = {
  none: "Sem repetição", one_time: "Único", daily: "Diário", weekly: "Semanal",
  biweekly: "Quinzenal", monthly: "Mensal", yearly: "Anual",
};

export const JOB_STATUS_PT = {
  pending: "Pendente", processing: "Processando", running: "Processando",
  completed: "Concluída", completed_with_errors: "Concluída com erros",
  failed: "Falhou", error: "Erro", rolled_back: "Desfeita",
};

export const ORDER_STATUS_PT = {
  draft: "Rascunho", requested: "Aguardando torrefador", accepted: "Aceita",
  in_production: "Em produção", completed: "Produção finalizada",
  invoiced: "NF emitida", billed: "Boleto enviado", paid: "Pago",
  rejected: "Rejeitada", canceled: "Cancelada", delivered: "Entregue",
};

export const labelPt = (map, v) => (v == null || v === "" ? "" : map[v] || v);
